import { createAction } from 'redux-actions';
import { Fund } from 'src/components/Exchange/types';
import { getEndpoint, callApi } from 'src/utils/api';

export const createApiActionCreator =
  (method: string) =>
  (type: string, endpointName: string, body: string | Fund) => {
    return (dispatch) => {
      const actionCreator = createAction(type);
      const endpoint = getEndpoint(endpointName);
      const promise = callApi(
        endpoint,
        { method: method },
        typeof body === 'string' ? body : JSON.stringify(body)
      );
      const action = actionCreator(promise);
      dispatch(action);
      return promise;
    };
  };

export const createApiPostActionCreator = createApiActionCreator('POST');
export const createApiPutActionCreator = createApiActionCreator('PUT');
